import { render, staticRenderFns } from "./Embalagem.vue?vue&type=template&id=6bccc064&lang=true"
import script from "./Embalagem.vue?vue&type=script&lang=js"
export * from "./Embalagem.vue?vue&type=script&lang=js"
import style0 from "./Embalagem.vue?vue&type=style&index=0&id=6bccc064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports